import { render, staticRenderFns } from "./PingTuanHomePage.vue?vue&type=template&id=f61cddb2&scoped=true"
import script from "./PingTuanHomePage.vue?vue&type=script&lang=js"
export * from "./PingTuanHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61cddb2",
  null
  
)

export default component.exports